/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
// import useFormValidator from 'useFormValidator';
import NumberFormat from 'react-number-format';
import DateInputPicker from 'modules/common/components/DateInputPicker2';

import useFormValidator from 'useFormValidator';

import { InputTemplate } from "../../../common/components/inputComponents";

import * as action from '../actions';
import * as c from '../constants';

const FORM_DATA = {
  year: "",
  advance_discount_percentage: "",
  january_discount_percentage: "",
  february_discount_percentage: "",
  march_discount_percentage: "",
  monthly_penalty_percentage: "",
  maximum_penalty_percentage: "",
}

const UpdateDiscountAndPenaltyModal = ({
  updateDiscountAndPenalty,
  getDiscountAndPenalty,
  item,
  id,
}) => {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState(FORM_DATA)

  const validateForm = useFormValidator(formData, {
    year: 'required',
    advance_discount_percentage: 'required',
    january_discount_percentage: 'required',
    february_discount_percentage: 'required',
    march_discount_percentage: 'required',
    monthly_penalty_percentage: 'required',
    maximum_penalty_percentage: 'required',
  });

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  useEffect(() => {
    if (item) {
      setFormData(prevForm => ({
        ...prevForm, 
        year: _.get(item, "attributes.year") || "",
        advance_discount_percentage: _.get(item, "attributes.advance_discount_percentage") || "",
        january_discount_percentage: _.get(item, "attributes.january_discount_percentage") || "",
        february_discount_percentage: _.get(item, "attributes.february_discount_percentage") || "",
        march_discount_percentage: _.get(item, "attributes.march_discount_percentage") || "",
        monthly_penalty_percentage: _.get(item, "attributes.monthly_penalty_percentage") || "",
        maximum_penalty_percentage: _.get(item, "attributes.maximum_penalty_percentage") || "",
      }))
    }
  }, [item])

  const handleOnSubmitUpdate = e => {
    e.preventDefault()

    updateDiscountAndPenalty(id, formData, () => {
      getDiscountAndPenalty()
    })
    setModal({ isOpen: false });
  }

  const handleOnChangeDate = key => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };
  
  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  return (
    <Modal.Body>
      <form className="" onSubmit={handleOnSubmitUpdate}>
        <div className="full-group-v2">
          <div className="form-row">
            <InputTemplate
              title="Year"
              htmlFor="year"
              containerClassName="col-6"
              formValidatorMsg={validateForm.renderMessage("year")}
              withCustomInputComponent={() => (
                <DateInputPicker
                  showYearPicker
                  inputClassName="full-input form-input-record-v2"
                  placeholder="YYYY"
                  btnClassName="button-date2-v2 cms-bg-color-secondary cms-outline-secondary"
                  onChange={handleOnChangeDate('year')}
                  value={String(_.get(formData, 'year')) || ""}
                />
              )}
            />
            <InputTemplate
              title="Additional Monthly Percentage"
              htmlFor="monthly_penalty_percentage"
              containerClassName="col-6"
              formValidatorMsg={validateForm.renderMessage("monthly_penalty_percentage")}
              withCustomInputComponent={() => (
                <NumberFormat
                  name="monthly_penalty_percentage"
                  id="monthly_penalty_percentage"
                  placeholder="0"
                  // className="full-input-v2 text-uppercase my-2"
                  className="full-input-v2"
                  onValueChange={values => {
                    const { floatValue } = values
                    setFormData(() => ({
                      ...formData,
                      monthly_penalty_percentage: floatValue
                    }));
                  }}
                  // disabled={isStatusPaid}
                  isNumericString
                  thousandSeparator
                  allowNegative
                  allowLeadingZeros
                  displayType="input"
                  prefix=""
                  value={_.get(formData, "monthly_penalty_percentage", 0) || 0}
                />
              )} 
            />
            <InputTemplate
              title="December (current year) Discount Percentage"
              htmlFor="advance_discount_percentage"
              containerClassName="col-6"
              formValidatorMsg={validateForm.renderMessage("advance_discount_percentage")}
              withCustomInputComponent={() => (
                <NumberFormat
                  name="advance_discount_percentage"
                  id="advance_discount_percentage"
                  placeholder="0"
                  // className="full-input-v2 text-uppercase my-2"
                  className="full-input-v2"
                  onValueChange={values => {
                    const { floatValue } = values
                    setFormData(() => ({
                      ...formData,
                      advance_discount_percentage: floatValue
                    }));
                  }}
                  // disabled={isStatusPaid}
                  isNumericString
                  thousandSeparator
                  allowNegative
                  allowLeadingZeros
                  displayType="input"
                  prefix=""
                  value={_.get(formData, "advance_discount_percentage", 0) || 0}
                />
              )} 
            />
            <InputTemplate
              title="January Discount Percentage"
              htmlFor="january_discount_percentage"
              containerClassName="col-6"
              formValidatorMsg={validateForm.renderMessage("january_discount_percentage")}
              withCustomInputComponent={() => (
                <NumberFormat
                  name="january_discount_percentage"
                  id="january_discount_percentage"
                  placeholder="0"
                  // className="full-input-v2 text-uppercase my-2"
                  className="full-input-v2"
                  onValueChange={values => {
                    const { floatValue } = values
                    setFormData(() => ({
                      ...formData,
                      january_discount_percentage: floatValue
                    }));
                  }}
                  // disabled={isStatusPaid}
                  isNumericString
                  thousandSeparator
                  allowNegative
                  allowLeadingZeros
                  displayType="input"
                  prefix=""
                  value={_.get(formData, "january_discount_percentage", 0) || 0}
                />
              )} 
            />
            <InputTemplate
              title="February Discount Percentage"
              htmlFor="february_discount_percentage"
              containerClassName="col-6"
              formValidatorMsg={validateForm.renderMessage("february_discount_percentage")}
              withCustomInputComponent={() => (
                <NumberFormat
                  name="february_discount_percentage"
                  id="february_discount_percentage"
                  placeholder="0"
                  // className="full-input-v2 text-uppercase my-2"
                  className="full-input-v2"
                  onValueChange={values => {
                    const { floatValue } = values
                    setFormData(() => ({
                      ...formData,
                      february_discount_percentage: floatValue
                    }));
                  }}
                  // disabled={isStatusPaid}
                  isNumericString
                  thousandSeparator
                  allowNegative
                  allowLeadingZeros
                  displayType="input"
                  prefix=""
                  value={_.get(formData, "february_discount_percentage", 0) || 0}
                />
              )} 
            />
            <InputTemplate
              title="March Discount Percentage"
              htmlFor="march_discount_percentage"
              containerClassName="col-6"
              formValidatorMsg={validateForm.renderMessage("march_discount_percentage")}
              withCustomInputComponent={() => (
                <NumberFormat
                  name="march_discount_percentage"
                  id="march_discount_percentage"
                  placeholder="0"
                  // className="full-input-v2 text-uppercase my-2"
                  className="full-input-v2"
                  onValueChange={values => {
                    const { floatValue } = values
                    setFormData(() => ({
                      ...formData,
                      march_discount_percentage: floatValue
                    }));
                  }}
                  // disabled={isStatusPaid}
                  isNumericString
                  thousandSeparator
                  allowNegative
                  allowLeadingZeros
                  displayType="input"
                  prefix=""
                  value={_.get(formData, "march_discount_percentage", 0) || 0}
                />
              )} 
            />
            <InputTemplate
              title="Maximum Monthly Penalty Percentage"
              htmlFor="maximum_penalty_percentage"
              containerClassName="col-6"
              formValidatorMsg={validateForm.renderMessage("maximum_penalty_percentage")}
              withCustomInputComponent={() => (
                <NumberFormat
                  name="maximum_penalty_percentage"
                  id="maximum_penalty_percentage"
                  placeholder="0"
                  // className="full-input-v2 text-uppercase my-2"
                  className="full-input-v2"
                  onValueChange={values => {
                    const { floatValue } = values
                    setFormData(() => ({
                      ...formData,
                      maximum_penalty_percentage: floatValue
                    }));
                  }}
                  // disabled={isStatusPaid}
                  isNumericString
                  thousandSeparator
                  allowNegative
                  allowLeadingZeros
                  displayType="input"
                  prefix=""
                  value={_.get(formData, "maximum_penalty_percentage", 0) || 0}
                />
              )} 
            />
          </div>
        </div>

        {/* Actions */}
        <div className="d-flex justify-content-center">
          <button
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          >
            <span className="font-weight-bold">
              {/* {updating ? <i className="fa fa-spin fa-spinner" /> : "Submit"} */}
              Submit
            </span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  )
}

UpdateDiscountAndPenaltyModal.propTypes = {
  updateDiscountAndPenalty: PropTypes.instanceOf(Function).isRequired,
  getDiscountAndPenalty: PropTypes.instanceOf(Function).isRequired,
  item: PropTypes.instanceOf(Object).isRequired,
  id: PropTypes.string.isRequired,
  // updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ }) => ({
  // profile: _.get(api, `${c.GET_SINGLE_USER_MANAGEMENT}.item`) || {},
  // updating: api.loading.indexOf(c.UPDATE_USER_MANAGEMENT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(UpdateDiscountAndPenaltyModal);